import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { ReferenceScheme } from '../models/reference-scheme.model';
import { ReferenceSchemeService } from '../services/reference-scheme.service';

@Injectable()
export class GetReferenceSchemeByIdResolver {
  private referenceSchemeService = inject(ReferenceSchemeService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.referenceSchemeService
      .getReferenceSchemeById(Number(route.paramMap.get('id')))
      .pipe(
        take(1),
        map((referenceScheme: ReferenceScheme) => referenceScheme),
      );
  }
}
